import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'failure-analysis';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CLEANUP = `${NAMESPACE}/CLEANUP`;

export const GET_FAILURE_TESTS = createApiNamespacedConstants('GET_FAILURE_TESTS');
export const GET_ROOT_CAUSES = createApiNamespacedConstants('GET_ROOT_CAUSES');
